<template>
  <aside class="dea-list-catalog bookmarks__sidebar bookmarks__sidebar--resources">
    <SidebarLinkList :items="bookmarkTypes" type="div"> </SidebarLinkList>
    <h3 v-if="typeLabels.length && showFilters" class="dea-list-catalog__label">Filtri</h3>
    <SearchCheckbox
      v-if="origins.length && showFilters"
      id="origin"
      data-test="filter-origin-checkbox"
      label="Salvate da:"
      :items="origins"
      filter="origin"
      :use-input="false"
      @trigger-search="triggerSearch"
    >
    </SearchCheckbox>
    <SearchCheckbox
      v-if="typeLabels.length && showFilters"
      id="type_label"
      data-test="filter-type-checkbox"
      label="Tipologia:"
      :items="typeLabels"
      filter="type_label"
      :use-input="false"
      @trigger-search="triggerSearch"
    >
    </SearchCheckbox>
    <DateSelect
      v-if="typeLabels.length && showFilters"
      label="Periodo di salvataggio"
      @trigger-search="triggerSearch('dates', $event)"
    />
  </aside>
</template>

<script>
import SidebarLinkList from "@/components/elements/SidebarLinkList";
import SearchCheckbox from "@/components/elements/SearchCheckbox";
import DateSelect from "@/components/elements/DateSelect";

export default {
  name: "SidebarBookmarks",
  components: { SidebarLinkList, SearchCheckbox, DateSelect },
  props: {
    bookmarkTypes: {
      type: Array,
      required: true,
    },
    origins: {
      type: Array,
      required: true,
    },
    typeLabels: {
      type: Array,
      required: true,
    },
    showFilters: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    triggerSearch(item, data) {
      this.$emit("trigger-search", item, data);
    },
  },
};
</script>

<style lang="scss">
@import "@/styles/system.utils";

.dea-list-catalog__label {
  @include vmargin($space-intermediate, 0);
}
</style>
